export const INDIVIDUAL_ACCOUNT_TYPE: string = 'Individual';
export const COMPANY_ACCOUNT_TYPE: string = 'Company';
